import React from "react"
import { Text, TouchableOpacity } from "react-native";
import { MaterialIcons } from '@expo/vector-icons';
import { styles } from 'styles/components/cloverPointConnectionStatuses';
import CloverConnectionStatusButtonProps from 'types/components/CloverConnectionStatusButtonProps';

export default ({ 
    borderColor, 
    fillColor,
    backgroundColor, 
    iconName, 
    text, 
    onPress,
    isForVenue,
    isFirstButton,
    isLastButton
}: CloverConnectionStatusButtonProps): JSX.Element => {

    return (
        <TouchableOpacity
            onPress={() => {
                if (onPress) onPress();
            }}
            style={{
                ...styles.cloverPointStatusChipContainer, 
                ...(isFirstButton ? styles.cloverPointStatusFirstChipContainer : null), 
                ...(isLastButton ? styles.cloverPointStatusLastChipContainer : null),
                backgroundColor: backgroundColor, 
                borderColor: borderColor, 
                borderWidth: borderColor ? 2 : 0,
                width: text ? isForVenue ? 70 : 70 : 50,
                justifyContent: text ? 'flex-start' : 'center'
                }}
        >
            <MaterialIcons                
                name={iconName}
                type="ionicon"
                color={fillColor}
                size={25}

            />
            {text && (
                <Text 
                    style={{
                    ...styles.cloverPointStatusText, 
                    color: fillColor
                    }}
                >
                    {text}
                </Text>     
            )}
        </TouchableOpacity>  
    )
}